<section id="secao-etapas-inovacao">
  <div class="container">
    <div class="row r-titulo">
      <h1 class="titulo">
        A Fundação Educere participa de todas as etapas da inovação, desde a
        ideação até a aceleração
      </h1>
    </div>
    <div class="row cards">
      <div class="card">
        <ul class="list-group list-group-flush">
          <li class="list-group-item">
            <span class="card-icon lamp material-icons">wb_incandescent</span>
          </li>
          <li class="list-group-item">
            <h5 class="etapas">Ideação</h5>
          </li>
          <li class="list-group-item">
            <span class="card-icon-ideacao material-icons">trending_flat</span>
          </li>
        </ul>
      </div>
      <!-- <div class="card">
        <ul class="list-group list-group-flush">
          <li class="list-group-item">
            <span class="card-icon material-icons">task</span>
          </li>
          <li class="list-group-item">
            <h5 class="etapas">Pré-incubação</h5>
          </li>
          <li class="list-group-item">
            <span class="card-icon-pre-incubacao material-icons"
              >trending_flat</span
            >
          </li>
        </ul>
      </div> -->
      <div class="card">
        <ul class="list-group list-group-flush">
          <li class="list-group-item">
            <span class="card-icon material-icons">egg</span>
          </li>
          <li class="list-group-item">
            <h5 class="etapas">Incubação</h5>
          </li>
          <li class="list-group-item">
            <span class="card-icon-incubacao material-icons"
              >trending_flat</span
            >
          </li>
        </ul>
      </div>
      <div class="card">
        <ul class="list-group list-group-flush">
          <li class="list-group-item">
            <span class="card-icon material-icons">rocket_launch</span>
          </li>
          <li class="list-group-item">
            <h5 class="etapas">Aceleração</h5>
          </li>
          <li class="list-group-item">
            <span class="card-icon-graduacao material-icons">
              trending_flat
            </span>
          </li>
        </ul>
      </div>
      <div class="card">
        <ul class="list-group list-group-flush">
          <li class="list-group-item">
            <span class="card-icon material-icons">workspace_premium</span>
          </li>
          <li class="list-group-item">
            <h5 class="etapas">Graduação</h5>
          </li>
          <li class="list-group-item">
            <span class="card-icon-aceleracao material-icons">
              trending_flat
            </span>
          </li>
        </ul>
      </div>
    </div>
  </div>
</section>
